import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'tour_loaded.deliveryitems.services.no_signature.count',
  label: 'Quittungslose Sendungen',
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.custom,
  category: 'delivery-items',
  description:
    '<p>Anzahl aller auf Tour geladenen Sendungen ohne Unterschriftenpflicht gezählt nach dem ersten ' +
    'abgeschlossenen Zustellvorgang</p>\n',
});
